// extracted by mini-css-extract-plugin
module.exports = {"container":"BraintreeService_container__XjIBs","paypalButton":"BraintreeService_paypalButton__1LjD_"};